(function() {
    // Find all bundle instances (in case of featured products + main product)
    const initBundles = () => {
        const containers = document.querySelectorAll('.bundle-wrapper:not([data-initialized])');
        
        containers.forEach(container => {
            const sectionId = container.getAttribute('data-section-id');
            const moneyFormat = container.getAttribute('data-money-format');
            const items = container.querySelectorAll('.bundle-item');

            // HELPER: Format money using Shopify's native format or fallback
            function formatMoney(cents, format) {
                if (typeof cents === 'string') cents = cents.replace('.', '');
                let value = '';
                const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                const formatString = format || "${{amount}}";

                function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
                    if (isNaN(number) || number == null) return 0;
                    number = (number / 100.0).toFixed(precision);
                    let parts = number.split('.');
                    let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                    let centsAmount = parts[1] ? decimal + parts[1] : '';
                    return dollarsAmount + centsAmount;
                }

                switch (formatString.match(placeholderRegex)[1]) {
                    case 'amount': value = formatWithDelimiters(cents, 2); break;
                    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
                    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
                    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
                }
                return formatString.replace(placeholderRegex, value);
            }

            function updatePriceUI() {
                const activeItem = container.querySelector('.bundle-item.active');
                if (!activeItem) return;

                const currentQty = parseInt(activeItem.dataset.qty);
                const nestedInput = container.querySelector('.qty-input');
                const finalQty = (currentQty === 4) ? parseInt(nestedInput.value) : currentQty;
                
                // Find the main product form
                const productForm = document.querySelector(`#product-form-${sectionId}`);
                if (!productForm) return;

                // Update or create quantity input in the actual form
                let qtyInput = productForm.querySelector('input[name="quantity"]');
                if (!qtyInput) {
                    qtyInput = document.createElement('input');
                    qtyInput.type = 'hidden';
                    qtyInput.name = 'quantity';
                    productForm.appendChild(qtyInput);
                }
                
                qtyInput.value = finalQty;
                // Dispatch event so the theme knows quantity changed (for dynamic checkout buttons)
                qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Click Handler
            container.addEventListener('click', (e) => {
                const item = e.target.closest('.bundle-item');
                if (!item || e.target.closest('.qty-controls')) return;

                items.forEach(i => i.classList.remove('active'));
                item.classList.add('active');
                
                const radio = item.querySelector('input[type="radio"]');
                if (radio) radio.checked = true;
                
                updatePriceUI();
            });

            // +/- Button Handler
            container.querySelectorAll('.qty-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const input = container.querySelector('.qty-input');
                    let val = parseInt(input.value);
                    val = (btn.dataset.action === 'plus') ? val + 1 : Math.max(4, val - 1);
                    input.value = val;
                    
                    const priceEl = container.querySelector('#price-4-plus');
                    const compareEl = container.querySelector('#compare-4-plus');

                    if (priceEl) {
                        const basePrice = parseFloat(priceEl.dataset.basePrice);
                        const finalPrice = basePrice * val * 0.90;
                        const originalPrice = basePrice * val;

                        priceEl.innerText = formatMoney(finalPrice, moneyFormat);
                        if (compareEl) compareEl.innerText = formatMoney(originalPrice, moneyFormat);
                    }
                    updatePriceUI();
                });
            });

            container.setAttribute('data-initialized', 'true');
            updatePriceUI();
        });
    };

    // Run on load
    initBundles();
    // Run if Shopify theme editor re-renders the section
    document.addEventListener('shopify:section:load', initBundles);
})();